/* eslint-disable no-mixed-operators */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useState,useEffect,useRef } from 'react'
import { Link,useNavigate,useLocation,useHistory ,useParams,useSearchParams,Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';

import moment from 'moment'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'; 
import Typography from '@mui/material/Typography';
import Breadcrumb from '../../../component/Breadcrumb'
import Express from '../FormComponent/Express';
import Procedures from '../FormComponent/Procedures';
import PaymentSideBlock from '../FormComponent/PaymentSideBlock';
import { Sa} from '../adsFormComp';
import FormSummary from '../FormSummary';
import CompleteAddress from '../CompleteAddress';
import PaymentForm from '../PaymentForm'
import PaymentSecond from '../PaymentSecond'
import Footer from '../../../component/Footer';
import FormSuccess from '../FormSuccess';
import axios from 'axios';
import { announceActions,alertActions } from '../../../_actions';
import ToastMessageComp from '../../../component/ToastMessageComp';
import { announceConstants } from '../../../_constants';
import PageLoaderComp from '../../../component/pageLoaderComp';

import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from '@stripe/stripe-js';
import { isValidEmail,isNumericValue,isValidPhoneNumber } from '../../../_helpers';
import { Ads_fullname,Ads_redirect } from '../../../_helpers/ads_fullname';
import { getDetailsBySiren,generateRandomString } from '../../../_helpers';

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`, {
  locale: 'fr' // Set the locale to French
});

export function SaStepperForm() {
 
  const appearance = {
    theme: 'stripe',
  };
 
  const [loading, setLoading] = useState(false);
  const [loadingFullpage, setLoadingFullpage] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [options, setOptions] = useState( {
    clientSecret,
    appearance,
  });

  const [queryParameters] = useSearchParams()
  const childRef = useRef();
  const announceIdRef = useRef("");

  const steps = ['Remplir le formulaire', 'Visualiser le récapitulatif', 'Adresse de facturation', 'Procéder au paiement', 'succès'];
  const alert = useSelector(state => state.alert);
  const dispatch = useDispatch(); 
  const location = useLocation(); 
  let navigate = useNavigate();
  let { ads,adsname,id } = useParams();
  
  const currentUser = useSelector(state => state.authentication.user);
  const announceData = useSelector(state => state.announce.announce);
  const [isCheckedSerenity,setIscheckedSerenity]=useState(false)
  const [is_general_conditions_sale,setis_general_conditions_sale]=useState(false)
  const [general_conditions_sale_msg,setgeneral_conditions_sale_msg]=useState("")
  const [announceDetails,setAnnounceDetails]=useState("")
  const [AdsFullName,setAdsFullName]=useState("")
  const [La_gerance, setLa_gerance] = useState([{
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    index:0,
    type_personne_lagrance:"",
    siren_lagrance:"",
    denomination_lagrance:"",
    forme_juridiquelagrance:"",
    capital_lagrance:"",
    civilite_lagrance:"",
    nomlagrance:"",
    prenomlagrance:"",
    adresselagrance:"",
    adresse_suitelagrance:"",
    code_postallagrance:"",
    resident_etrangerlagrancephysic:"",
    villelagrance:"",
    villelagranceArr:[],
    ville_id_lagrance:"",
    greffelagrance:"",
    payslagrance:"",
  }]);
  const [Les_president, setLes_president] = useState([{
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    index:0,
    type_personne_Associes:"",
    siren_Associes:"",
    denomination_Associes:"",
    forme_juridiqueAssocies:"",
    capital_Associes:"",
    civilite_Associes:"",
    nomAssocies:"",
    prenomAssocies:"",
    adresseAssocies:"",
    adresse_suiteAssocies:"",
    code_postalAssocies:"",
    resident_etrangerAssociesphysic:"Non",
    villeAssocies:"",
    villeAssociesArr:[],
    ville_id_Associes:"",
    greffeAssocies:"",
    paysAssocies:"",
  }]);
  
  const [ Directeur_general, setDirecteur_general] = useState({
    show_data:"Non",
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    index:0,
    type_personne_titulaire:"",
    civilite_titulaire_physique:"",
    nom_titulaire_physique:"",
    prenom_titulaire_physique:"",
    adresse_titulaire_physique:"",
    adresse_suite_titulaire_physique:"",
    resident_etrangerTitulairephysic:"",
    code_postal_titulaire_physique:"",
    ville_titulaire_physique:"",
    rcs_titulaire:"",
    denomination_titulaire:"",
    forme_juridique_titulaire:"",
    capital_titulaire:"",
    adresse_titulaire:"",
    adresse_suite_titulaire:"",
    code_postal_titulaire:"",
    ville_titulaire:"",
    ville_titulaireArr:[],
    ville_id_titulaire:"",
    greffe_titulaire:""   ,  
    civilite_representee_titulaire:""  ,  
    nom_representee_titulaire:""  ,  
    prenom_representee_titulaire:""  ,  
  });
  const Directeur_generalRef = useRef(Directeur_general);
  const [ Directeur_general_delegue , setDirecteur_general_delegue] = useState([{
    show_data:"Non",
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    index:0,
    type_personne_titulaire:"",
    civilite_titulaire_physique:"",
    nom_titulaire_physique:"",
    prenom_titulaire_physique:"",
    adresse_titulaire_physique:"",
    adresse_suite_titulaire_physique:"",
    resident_etrangerTitulairephysic:"",
    code_postal_titulaire_physique:"",
    ville_titulaire_physique:"",
    rcs_titulaire:"",
    denomination_titulaire:"",
    forme_juridique_titulaire:"",
    capital_titulaire:"",
    adresse_titulaire:"",
    adresse_suite_titulaire:"",
    code_postal_titulaire:"",
    ville_titulaire:"",
    ville_titulaireArr:[],
    ville_id_titulaire:"",
    greffe_titulaire:""    
  }]);
  const [Administrateurs , setAdministrateurs] = useState([{
    show_data:"Non",
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    index:0,
    type_personne_titulaire:"",
    civilite_titulaire_physique:"",
    nom_titulaire_physique:"",
    prenom_titulaire_physique:"",
    adresse_titulaire_physique:"",
    adresse_suite_titulaire_physique:"",
    resident_etrangerTitulairephysic:"",
    code_postal_titulaire_physique:"",
    ville_titulaire_physique:"",
    rcs_titulaire:"",
    denomination_titulaire:"",
    forme_juridique_titulaire:"",
    capital_titulaire:"",
    adresse_titulaire:"",
    adresse_suite_titulaire:"",
    code_postal_titulaire:"",
    ville_titulaire:"",
    ville_titulaireArr:[],
    ville_id_titulaire:"",
    greffe_titulaire:""    
  }]);
  const [CommissaireAuxComptes, setCommissaireAuxComptes] = useState({
    show_data:"Non",
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    CAC_titulaire:{
      user_id:currentUser&&currentUser.data?currentUser.data.id:"",
      index:0,
      type_personne_titulaire:"",
      civilite_titulaire_physique:"",
      nom_titulaire_physique:"",
      prenom_titulaire_physique:"",
      adresse_titulaire_physique:"",
      adresse_suite_titulaire_physique:"",
      resident_etrangerTitulairephysic:"",
      code_postal_titulaire_physique:"",
      ville_titulaire_physique:"",
      rcs_titulaire:"",
      denomination_titulaire:"",
      forme_juridique_titulaire:"",
      capital_titulaire:"",
      adresse_titulaire:"",
      adresse_suite_titulaire:"",
      code_postal_titulaire:"",
      ville_titulaire:"",
      ville_titulaireArr:[],
      ville_id_titulaire:"",
      greffe_titulaire:""
    },
    CAC_suppleant:{
      user_id:currentUser&&currentUser.data?currentUser.data.id:"",
      index:0,
      type_personne_suppleant:"",
      civilite_suppleant_physique:"",
      nom_suppleant_physique:"",
      prenom_suppleant_physique:"",
      adresse_suppleant_physique:"",
      adresse_suite_suppleant_physique:"",
      code_postal_suppleant_physique:"",
      ville_suppleant_physique:"",
      rcs_suppleant:"",
      denomination_suppleant:"",
      forme_juridique_suppleant:"",
      capital_suppleant:"",
      adresse_suppleant:"",
      adresse_suite_suppleant:"",
      code_postal_suppleant:"",
      ville_suppleant:"",
      ville_suppleantArr:[],
      ville_id_suppleant:"",
      greffe_suppleant:"",
      resident_etrangerSuppleantPhysic:""
    }
    
  });
  const [ Transmission_des_actions , setTransmission_des_actions] = useState({
    show_data:"Texte libre",
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    texte:"",
       
  });
  const [Admission_assemblees , setAdmission_assemblees] = useState({
    show_data:"Texte libre",
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    texte:"",
       
  });
  const [formData,setFormData]= useState({
    "announce_id":id?id:announceData?announceData.announce_id:"",title:(ads.split("-")).join(" "),add_type_full:AdsFullName, add_type:adsname?adsname:"",form_type:adsname?adsname:"",type_acte:"",nom_famille:"",officiant_to:"",date_acte:"",denomination:"",sigle:"",enseigne_commerciale:"",forme_juridique:"",objet:"",capital:"",capital_initial:"",capital_min:"",capital_max:"",duree:"",adresse:"",adresse_suite:"",code_postal:"",ville:"",villeArr:[],ville_id:"",greffe:"",Directeur_general:Directeur_general,Directeur_general_delegue:Directeur_general_delegue,Les_president:Les_president,CommissaireAuxComptes:CommissaireAuxComptes,Transmission_des_actions:Transmission_des_actions,Admission_assemblees:Admission_assemblees,Administrateurs:Administrateurs });

  const [isSubmitted, setSubmitted] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [successful, setSuccessful] = useState(false);
  const [userSelectedAddress, setUserSelectedAddress] = useState({
    "announce_id":id,
    "user_id":currentUser && currentUser.data?currentUser.data.id:"",
    "delivery_address":currentUser && currentUser.user_address?currentUser.user_address[0]:"",
    "shipping_address":currentUser && currentUser.user_address?currentUser.user_address[0]:"",
    "email":currentUser && currentUser.data?currentUser.data.email:"",
    "telephone":currentUser && currentUser.data?currentUser.data.telephone:"",
    "billing_address_type":"account_address",
    "billing_address_denomination":currentUser && currentUser.data?currentUser.data.raisosociale:"",
    "billing_address_civility":currentUser && currentUser.data?currentUser.data.civil:"",
    "billing_address_nom":currentUser && currentUser.data?currentUser.data.firstname:"",
    "billing_address_prenom":currentUser && currentUser.data?currentUser.data.lastname:"",
    "billing_address_address":currentUser && currentUser.data?currentUser.data.adresse:"",
    "billing_address_code_postal":currentUser && currentUser.data?currentUser.data.postalcode:"",
    "billing_address_ville":currentUser && currentUser.data?currentUser.data.ville:"",
    "billing_address_ville_id":currentUser && currentUser.data?currentUser.data.ville_id:"",
    "billing_address_villeArr":currentUser && currentUser.data&& currentUser.data.villeArr?JSON.parse(currentUser.data.villeArr):[],
  });
  
  const [payamentPrice,sePayamentPrice]=useState(0);
  const [paymentData,setPaymentData]=useState("");
 useEffect(() => {if(id){setFormData({...formData,announce_id: id});}}, [id])
  useEffect(() => {
    window.scrollTo(0, 0)
    setAdsFullName(Ads_fullname(adsname));
    if(id){
      let announce = {
        "data":[],
        "announce_id":id 
      }
      dispatch({ type: announceConstants.CREATE_SUCCESS, announce});
    }
    if(localStorage.getItem("activeStep")){
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }
      setActiveStep(parseInt(localStorage.getItem("activeStep")))
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped); 
    }
    if(!queryParameters.get("activstep") && id){
      // setActiveStep(1);
      getAnnounceDetails(id);
    }
    
  }, [])
  
  useEffect(() => { 
    if(announceDetails){
      let announceDetailsGet = announceDetails.data;
      let La_geranceGet =announceDetailsGet.votre_annonce_json.La_gerance || [];
      let Les_presidentGet =announceDetailsGet.votre_annonce_json.Les_president;
      let CommissaireAuxComptesGet =announceDetailsGet.votre_annonce_json.CommissaireAuxComptes;
      let Directeur_generalGet =announceDetailsGet.votre_annonce_json.Directeur_general;
      let Directeur_general_delegueGet =announceDetailsGet.votre_annonce_json.Directeur_general_delegue;
      let Transmission_des_actionsGet =announceDetailsGet.votre_annonce_json.Transmission_des_actions;
      let Admission_assembleesGet =announceDetailsGet.votre_annonce_json.Admission_assemblees;
      let AdministrateursGet =announceDetailsGet.votre_annonce_json.Administrateurs;
       if(La_geranceGet.length>=0){
        La_geranceGet.map((val,key)=>{
          val.user_id=currentUser&&currentUser.data?currentUser.data.id:"";
          return val;
        })
      } 
      if(Les_presidentGet.length>=0){
        Les_presidentGet.map((val,key)=>{
          val.user_id=currentUser&&currentUser.data?currentUser.data.id:"";
          return val;
        })
      }
      if(AdministrateursGet.length>=0){
        AdministrateursGet.map((val,key)=>{
          val.user_id=currentUser&&currentUser.data?currentUser.data.id:"";
          return val;
        })
      }
      if(Directeur_general_delegueGet.length>=0){
        Directeur_general_delegueGet.map((val,key)=>{
          val.user_id=currentUser&&currentUser.data?currentUser.data.id:"";
          return val;
        })
      }
      announceDetailsGet.votre_annonce_json.La_gerance=La_geranceGet;
      announceDetailsGet.votre_annonce_json.Les_president=Les_presidentGet;
      announceDetailsGet.votre_annonce_json.CommissaireAuxComptes=CommissaireAuxComptesGet;
      announceDetailsGet.votre_annonce_json.Directeur_general=Directeur_generalGet;
      announceDetailsGet.votre_annonce_json.Directeur_general_delegue=Directeur_general_delegueGet;
      announceDetailsGet.votre_annonce_json.Transmission_des_actions=Transmission_des_actionsGet;
      announceDetailsGet.votre_annonce_json.Admission_assemblees=Admission_assembleesGet;
      announceDetailsGet.votre_annonce_json.announce_id=id?id:"";
      announceDetailsGet.votre_annonce_json.title=ads?(ads.split("-")).join(" "):"";
      setLa_gerance(La_geranceGet);
      setLes_president(Les_presidentGet);
      setCommissaireAuxComptes(CommissaireAuxComptesGet);
      setDirecteur_general(Directeur_generalGet);
      setDirecteur_general_delegue(Directeur_general_delegueGet);
      setAdministrateurs(AdministrateursGet);
      setTransmission_des_actions(Transmission_des_actionsGet);
      setAdmission_assemblees(Admission_assembleesGet);

      setFormData(announceDetailsGet.votre_annonce_json);
    }
  }, [announceDetails])

  useEffect(() => {  
    if(paymentData && paymentData.data){
      sePayamentPrice(parseFloat(parseFloat(paymentData.data.total)+(isCheckedSerenity?118.80:0)).toFixed(2))
    }
    
  }, [isCheckedSerenity,paymentData])

useEffect(() => {
  Directeur_generalRef.current = Directeur_general;

}, [Directeur_general])

  useEffect(() => {  
    if(queryParameters.get("activstep")  && id && ( (queryParameters.get("payment_intent") && queryParameters.get("payment_intent_client_secret")) || (currentUser && currentUser.UserProDetails && currentUser.UserProDetails.details && currentUser.UserProDetails.details.payment_plan !== null && currentUser.UserProDetails.details.payment_plan.includes("monthly")) )){
      const getDetails = async () => {
        const details_response = await getAnnounceDetails(id);
        if(details_response.success){
          if(parseInt(details_response.data.data.status) === 1 || parseInt(details_response.data.data.status) === 2){
            let data = {
              "announce_id":id,
              "payment_order_id":moment().format("DDMMY")+"_"+id.padStart(8, '0'),
              "invoice_number":moment().format("DDMMY")+"_"+id.padStart(8, '0'),
              "invoice_date":moment().format("DD-MM-Y"),
              "date_payment":moment().format("DD-MM-Y"),
              "payment_intent":queryParameters.get("payment_intent"),
              "payment_price":details_response.data.data.total,
              "payment_intent_client_secret":queryParameters.get("payment_intent_client_secret"),
            }
            const update_response = await updateAnnouncePayment(data);
            
          }
        }
      };    
      getDetails();
    }
    
  }, [queryParameters.get("activstep"),queryParameters.get("payment_intent"),queryParameters.get("payment_intent_client_secret")])

  useEffect(() => {
    const getData = setTimeout(async() => {
      setFormData(formData => ({ ...formData, ["ville"]: "",["ville_id"]: "",["villeArr"]:[],["greffe"]: ""  }));  
      if(formData.code_postal.length>0){
        const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${formData.code_postal}`);        
        if( response.data &&  response.data.data){
          setFormData(formData => ({ ...formData, ["ville"]: response.data.data.city,["ville_id"]: response.data.data.id,["villeArr"]: response.data.data.cityArr,["greffe"]: response.data.data.area  }));
        }
      }      
    }, 1000)
    return () => clearTimeout(getData);
  }, [formData.code_postal])
  
  function removeForm(index,type="lagrance"){
    if(type=== "lagrance"){
      let values = [...La_gerance];
      values.splice(index, 1);
      setLa_gerance(values);
      setFormData(formData => ({ ...formData, ["La_gerance"]: values }));
    }
    if(type === "Associes"){
      let values = [...Les_president];
      values.splice(index, 1);
      setLes_president(values);
      setFormData(formData => ({ ...formData, ["Les_president"]: values }));
    }
    if(type === "Directeur_general_delegue"){
      let values = [...Directeur_general_delegue];
      values.splice(index, 1);
      setDirecteur_general_delegue(values);
      setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values }));
    }
    if(type === "Administrateurs"){
      let values = [...Administrateurs];
      values.splice(index, 1);
      setAdministrateurs(values);
      setFormData(formData => ({ ...formData, ["Administrateurs"]: values }));
    }
  }
  function addForm(e,type="lagrance") {
    if(type=== "lagrance"){
      let values = [...La_gerance];
      values.push({
        user_id:currentUser&&currentUser.data?currentUser.data.id:"",
        index:values.length,
        type_personne_lagrance:"",
        siren_lagrance:"",
        denomination_lagrance:"",
        forme_juridiquelagrance:"",
        capital_lagrance:"",
        civilite_lagrance:"",
        nomlagrance:"",
        prenomlagrance:"",
        adresselagrance:"",
        adresse_suitelagrance:"",
        resident_etrangerlagrancephysic:"Non",
        code_postallagrance:"",
        villelagrance:"",
        villelagranceArr:[],
        ville_id_lagrance:"",
        greffelagrance:"",
        payslagrance:"",
      });
      setLa_gerance(values);
      setFormData(formData => ({ ...formData, ["La_gerance"]: values }));
    }
    if(type === "Associes"){
      let values = [...Les_president];
      values.push({
        user_id:currentUser&&currentUser.data?currentUser.data.id:"",
        index:values.length,
        type_personne_Associes:"",
        siren_Associes:"",
        denomination_Associes:"",
        forme_juridiqueAssocies:"",
        capital_Associes:"",
        civilite_Associes:"",
        nomAssocies:"",
        prenomAssocies:"",
        adresseAssocies:"",
        adresse_suiteAssocies:"",
        code_postalAssocies:"",
        resident_etrangerAssociesphysic:"Non",
        villeAssocies:"",
        villeAssociesArr:[],
        ville_id_Associes:"",
        greffeAssocies:"",
        paysAssocies:"",
      });
      setLes_president(values);
      setFormData(formData => ({ ...formData, ["Les_president"]: values }));
    }
   
    if(type === "Directeur_general_delegue"){
      let values = [...Directeur_general_delegue];
      values.push({
        index:values.length,
        show_data:"Non",
        user_id:currentUser&&currentUser.data?currentUser.data.id:"",
        type_personne_titulaire:"",
        civilite_titulaire_physique:"",
        nom_titulaire_physique:"",
        prenom_titulaire_physique:"",
        adresse_titulaire_physique:"",
        adresse_suite_titulaire_physique:"",
        resident_etrangerTitulairephysic:"",
        code_postal_titulaire_physique:"",
        ville_titulaire_physique:"",
        rcs_titulaire:"",
        denomination_titulaire:"",
        forme_juridique_titulaire:"",
        capital_titulaire:"",
        adresse_titulaire:"",
        adresse_suite_titulaire:"",
        code_postal_titulaire:"",
        ville_titulaire:"",
        ville_titulaireArr:[],
        ville_id_titulaire:"",
        greffe_titulaire:""
      });
      setDirecteur_general_delegue(values);
      setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values }));
    }
    if(type === "Administrateurs"){
      let values = [...Administrateurs];
      values.push({
        index:values.length,
        show_data:"Non",
        user_id:currentUser&&currentUser.data?currentUser.data.id:"",
        type_personne_titulaire:"",
        civilite_titulaire_physique:"",
        nom_titulaire_physique:"",
        prenom_titulaire_physique:"",
        adresse_titulaire_physique:"",
        adresse_suite_titulaire_physique:"",
        resident_etrangerTitulairephysic:"",
        code_postal_titulaire_physique:"",
        ville_titulaire_physique:"",
        rcs_titulaire:"",
        denomination_titulaire:"",
        forme_juridique_titulaire:"",
        capital_titulaire:"",
        adresse_titulaire:"",
        adresse_suite_titulaire:"",
        code_postal_titulaire:"",
        ville_titulaire:"",
        ville_titulaireArr:[],
        ville_id_titulaire:"",
        greffe_titulaire:""
      });
      setAdministrateurs(values);
      setFormData(formData => ({ ...formData, ["Administrateurs"]: values }));
    }
    
    
  }
  async function handleChangeAddForm(e,index,type="lagrance") {
    let { name, value } = e.target;
    if(type=== "lagrance"){
      if(name ==="code_postallagrance"){
        await getCityFromPostal(name,value,index,type);
      }
      let values = [...La_gerance];
      
      if(name == "ville_id_lagrance"){        
        let cityArrFilter = values[index].villelagranceArr.filter((val,i)=>val.id==value);
        values[index]["villelagrance"] = cityArrFilter[0].city;
        values[index]["ville_id_lagrance"] = value;
        setLa_gerance(values);
        setFormData(formData => ({ ...formData, ["La_gerance"]: values }));

      }else{
        values[index][name] = value;
        setLa_gerance(values);
        setFormData(formData => ({ ...formData, ["La_gerance"]: values }));
      }
    }
    
    if(type=== "Associes"){

      if(name ==="code_postalAssocies"){
        await getCityFromPostal(name,value,index,type);
      }
      if(name === "siren_Associes"){
        await getSirenDetailsBySiren(name,value,index,type);
      }
      let values = [...Les_president];
      if(name == "ville_id_Associes"){        
        let cityArrFilter = values[index].villeAssociesArr.filter((val,i)=>val.id==value);
        values[index]["villeAssocies"] = cityArrFilter[0].city;
        values[index]["ville_id_Associes"] = value;
        values[index][name] = value;
        setLes_president(values);
        setFormData(formData => ({ ...formData, ["Les_president"]: values }));

      }else{
        values[index][name] = value;
        setLes_president(values);
        setFormData(formData => ({ ...formData, ["Les_president"]: values }));
      }
      
      
    }
    if(type === "Directeur_general"){
      let values = Directeur_generalRef.current;  
      if(name =="ville_id_titulaire"){        
        let cityArrFilter = values.ville_titulaireArr.filter((val,i)=>val.id==value);        
        values["ville_titulaire"] = cityArrFilter[0].city;
        values["ville_id_titulaire"] = value;        
        setDirecteur_general(values);
        setFormData(formData => ({ ...formData, ["Directeur_general"]: values }));

      }else{        
                
        values[name] = value;    
        setDirecteur_general(values);       
        setFormData(formData => ({ ...formData, ["Directeur_general"]: values }));
      }

      if(name === "code_postal_titulaire"){
        await getCityFromPostalType(name,value,0,"Directeur_general");
      }
      
      if(name === "rcs_titulaire"){
        await getSirenDetailsBySiren(name,value,index,type);
      }

    }
    if(type === "Directeur_general_delegue"){

      let values = [...Directeur_general_delegue];   
      if(name =="ville_id_titulaire"){
        let cityArrFilter = values[index].ville_titulaireArr.filter((val,i)=>val.id==value);        
        values[index]["ville_titulaire"] = cityArrFilter[0].city;
        values[index]["ville_id_titulaire"] = value;
        values[index][name] = value;
        setDirecteur_general_delegue(values);
        setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values }));

      }else{        
        values[index][name] = value;
        setDirecteur_general_delegue(values);
        setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values }));
      }   
      if(name === "code_postal_titulaire"){
        await getCityFromPostalType(name,value,index,"Directeur_general_delegue");
      }

      if(name === "rcs_titulaire"){
        await getSirenDetailsBySiren(name,value,index,type);
      }
      /* values[index][name] = value;
      setDirecteur_general_delegue(values);
      setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values })); */
    }
    if(type === "Administrateurs"){
      let values = [...Administrateurs];    
      if(name =="ville_id_titulaire"){
        let cityArrFilter = values[index].ville_titulaireArr.filter((val,i)=>val.id==value);        
        values[index]["ville_titulaire"] = cityArrFilter[0].city;
        values[index]["ville_id_titulaire"] = value;
        values[index][name] = value;
        setAdministrateurs(values);
        setFormData(formData => ({ ...formData, ["Administrateurs"]: values }));

      }else{        
        values[index][name] = value;
        setAdministrateurs(values);
        setFormData(formData => ({ ...formData, ["Administrateurs"]: values }));
      }  
      

      if(name === "code_postal_titulaire"){
        await getCityFromPostalType(name,value,index,"Administrateurs");
      }
      if(name === "rcs_titulaire"){
        await getSirenDetailsBySiren(name,value,index,type);
      }
      
    }
    if(type === "commissaireAuxComptes"){      
      let values = {...CommissaireAuxComptes};           
      if(name === "show_data"){
        values[name] = value;
      }
      setCommissaireAuxComptes(values);
      setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));
    }
    if(type === "CAC_titulaire"){

      let values = {...CommissaireAuxComptes};     
      
      if(name == "ville_id_titulaire"){        
        let cityArrFilter = values["CAC_titulaire"].ville_titulaireArr.filter((val,i)=>val.id==value);
        values["CAC_titulaire"]["ville_titulaire"] = cityArrFilter[0].city;
        values["CAC_titulaire"]["ville_id_titulaire"] = value;
        setCommissaireAuxComptes(values);
        setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));

      }else{
        
        values["CAC_titulaire"][name] = value;
        setCommissaireAuxComptes(values);
        setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));
      }
      
      if(name === "code_postal_titulaire"){
        await getCityFromPostalType(name,value,0,"CAC_titulaire");
      }
      if(name === "rcs_titulaire"){
        await getSirenDetailsBySiren(name,value,index,type);
      }
            
      /* let values = {...CommissaireAuxComptes};
      values["CAC_titulaire"][name] = value;
      setCommissaireAuxComptes(values);
      setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values })); */
    }
    if(type === "CAC_suppleant"){
      let values = {...CommissaireAuxComptes};

      if(name == "ville_id_suppleant"){        
        let cityArrFilter = values["CAC_suppleant"].ville_suppleantArr.filter((val,i)=>val.id==value);
        values["CAC_suppleant"]["ville_suppleant"] = cityArrFilter[0].city;
        values["CAC_suppleant"]["ville_id_suppleant"] = value;
        setCommissaireAuxComptes(values);
        setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));

      }else{        
        values["CAC_suppleant"][name] = value;
        setCommissaireAuxComptes(values);
        setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));
      }
      if(name === "rcs_suppleant"){
        await getSirenDetailsBySiren(name,value,index,type);
      }
      if(name ==="code_postal_suppleant"){
        await getCityFromPostalType(name,value,0,"CAC_suppleant");
      }
      /* let values = {...CommissaireAuxComptes};
      values["CAC_suppleant"][name] = value;
      setCommissaireAuxComptes(values);
      setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values })); */
    } 
    if(type === "Transmission_des_actions"){
      let values = {...Transmission_des_actions};  
      values[name] = value;
      if(name == "show_data"){
        if(value === "Texte libre"){
          values["texte"] = "";
        }else{
          values["texte"] = "Actions librement cessibles entre associés uniquement.";
        }
      }      
      setTransmission_des_actions(values);
      setFormData(formData => ({ ...formData, ["Transmission_des_actions"]: values }));
    }
   
    if(type === "Admission_assemblees"){
      let values = {...Admission_assemblees}; 
      values[name] = value;
      if(name == "show_data"){
        if(value === "Texte libre"){
          values["texte"] = "";
        }else{
          values["texte"] = "Tout Actionnaire est convoqué aux Assemblées. Chaque action donne droit à une voix.";
        }
      }
      setAdmission_assemblees(values);
      setFormData(formData => ({ ...formData, ["Admission_assemblees"]: values }));
    }
    
  }
  
  async function getSirenDetailsBySiren(name,value,index,type="lagrance"){ 
    
    const getSiren = setTimeout(async() => {
      
      if(type === "Associes"){  

        let values =  [...Les_president];
        // values[index]["siren_Associes"] =value;
        values[index]["denomination_Associes"] = "";
        values[index]["forme_juridiqueAssocies"] = "";
        values[index]["capital_Associes"] = "";
        values[index]["adresseAssocies"] = "";
        values[index]["code_postalAssocies"] = "";
        values[index]["villeAssocies"] = "";
        values[index]["ville_id_Associes"] ="";
        values[index]["villeAssociesArr"] = [];
        values[index]["greffeAssocies"] = "";
        setLes_president(values);
        setFormData(formData => ({ ...formData, ["Les_president"]: values })); 
        if(value.length>0){
          let getDetails = await getDetailsBySiren(value);    
          let values = [...Les_president]; 
         
          // values[index]["siren_Associes"] =value;
          values[index]["denomination_Associes"] =getDetails.denomination;
          values[index]["forme_juridiqueAssocies"] = getDetails.forme_juridique;
          values[index]["capital_Associes"] = getDetails.capital_social;
          values[index]["adresseAssocies"] = getDetails.adresse_rcs;
          values[index]["code_postalAssocies"] =getDetails.code_postal;
          values[index]["villeAssocies"] =getDetails.ville;
          values[index]["ville_id_Associes"] =getDetails.ville_id;
          values[index]["villeAssociesArr"] = getDetails.cityArr;
          values[index]["greffeAssocies"] = getDetails.area;
          setLes_president(values);
          setFormData(formData => ({ ...formData, ["Les_president"]: values }));  
        }
      }
      if(type === "Directeur_general"){    
        let values = Directeur_generalRef.current; 
        // values["rcs_titulaire"] =value;
        values["denomination_titulaire"] = "";
        values["forme_juridique_titulaire"] = "";
        values["capital_titulaire"] = "";
        values["adresse_titulaire"] = "";
        values["code_postal_titulaire"] = "";
        values["ville_titulaire"] = "";
        values["ville_id_titulaire"] = "";
        values["ville_titulaireArr"] = [];
        values["greffe_titulaire"] = "";
        setDirecteur_general(values);
        setFormData(formData => ({ ...formData, ["Directeur_general"]: values }));     
        if(value.length>0){
          let getDetails = await getDetailsBySiren(value);    
          let values = Directeur_generalRef.current; 
          // values["rcs_titulaire"] =value;     
          values["denomination_titulaire"] = getDetails.denomination;
          values["forme_juridique_titulaire"] = getDetails.forme_juridique;
          values["capital_titulaire"] = getDetails.capital_social;
          values["adresse_titulaire"] = getDetails.adresse_rcs;
          values["code_postal_titulaire"] = getDetails.code_postal;
          values["ville_titulaire"] = getDetails.ville;
          values["greffe_titulaire"] = getDetails.area;
          values["ville_id_titulaire"] =getDetails.ville_id;
          values["ville_titulaireArr"] = getDetails.cityArr;
          setDirecteur_general(values);
          setFormData(formData => ({ ...formData, ["Directeur_general"]: values }));   
        }
      }
      if(type === "Directeur_general_delegue"){ 
       
        let values =  [...Directeur_general_delegue];        
        // values[index]["rcs_titulaire"] =value;
        values[index]["denomination_titulaire"] = "";
        values[index]["forme_juridique_titulaire"] = "";
        values[index]["capital_titulaire"] = "";
        values[index]["adresse_titulaire"] = "";
        values[index]["code_postal_titulaire"] = "";
        values[index]["ville_titulaire"] = "";
        values[index]["greffe_titulaire"] = "";  
        values[index]["ville_id_titulaire"] = "";
        values[index]["ville_titulaireArr"] = [];        
        setDirecteur_general_delegue(values);
        setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values }));
        if(value.length>0){
          let getDetails = await getDetailsBySiren(value);    
          let values = [...Directeur_general_delegue];          
          // values[index]["rcs_titulaire"] =value;
          values[index]["denomination_titulaire"] =getDetails.denomination;
          values[index]["forme_juridique_titulaire"] = getDetails.forme_juridique;
          values[index]["capital_titulaire"] = getDetails.capital_social;
          values[index]["adresse_titulaire"] = getDetails.adresse_rcs;
          values[index]["code_postal_titulaire"] =getDetails.code_postal;
          values[index]["ville_titulaire"] =getDetails.ville;
          values[index]["greffe_titulaire"] = getDetails.area;
          values[index]["ville_id_titulaire"] =getDetails.ville_id;
          values[index]["ville_titulaireArr"] = getDetails.cityArr;
          setDirecteur_general_delegue(values);
          setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values })); 
        }
      }
      if(type === "Administrateurs"){        
        let values =  [...Administrateurs];        
        // values[index]["rcs_titulaire"] =value;
        values[index]["denomination_titulaire"] = "";
        values[index]["forme_juridique_titulaire"] = "";
        values[index]["capital_titulaire"] = "";
        values[index]["adresse_titulaire"] = "";
        values[index]["code_postal_titulaire"] = "";
        values[index]["ville_titulaire"] = "";
        values[index]["greffe_titulaire"] = "";        
        setAdministrateurs(values);
        setFormData(formData => ({ ...formData, ["Administrateurs"]: values }));
        if(value.length>0){
          let getDetails = await getDetailsBySiren(value);    
          let values = [...Administrateurs];          
          // values[index]["rcs_titulaire"] =value;
          values[index]["denomination_titulaire"] =getDetails.denomination;
          values[index]["forme_juridique_titulaire"] = getDetails.forme_juridique;
          values[index]["capital_titulaire"] = getDetails.capital_social;
          values[index]["adresse_titulaire"] = getDetails.adresse_rcs;
          values[index]["code_postal_titulaire"] =getDetails.code_postal;
          values[index]["ville_titulaire"] =getDetails.ville;
          values[index]["greffe_titulaire"] = getDetails.area;
          setAdministrateurs(values);
          setFormData(formData => ({ ...formData, ["Administrateurs"]: values })); 
        }
      }
      if(type === "CAC_titulaire"){ 
        
        let values = {...CommissaireAuxComptes};             
        // values[index]["rcs_titulaire"] =value;
        values["CAC_titulaire"]["denomination_titulaire"] = "";
        values["CAC_titulaire"]["forme_juridique_titulaire"] = "";
        values["CAC_titulaire"]["capital_titulaire"] = "";
        values["CAC_titulaire"]["adresse_titulaire"] = "";
        values["CAC_titulaire"]["code_postal_titulaire"] = "";
        values["CAC_titulaire"]["ville_titulaire"] = "";
        values["CAC_titulaire"]["ville_titulaireArr"] =[];
        values["CAC_titulaire"]["ville_id_titulaire"] = "";
        values["CAC_titulaire"]["greffe_titulaire"] = "";        
        setCommissaireAuxComptes(values);
        setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));
        if(value.length>0){
          let getDetails = await getDetailsBySiren(value);    
          let values = {...CommissaireAuxComptes}          
          // values[index]["rcs_titulaire"] =value;
          values["CAC_titulaire"]["denomination_titulaire"] =getDetails.denomination;
          values["CAC_titulaire"]["forme_juridique_titulaire"] = getDetails.forme_juridique;
          values["CAC_titulaire"]["capital_titulaire"] = getDetails.capital_social;
          values["CAC_titulaire"]["adresse_titulaire"] = getDetails.adresse_rcs;
          values["CAC_titulaire"]["code_postal_titulaire"] =getDetails.code_postal;
          values["CAC_titulaire"]["ville_titulaire"] =getDetails.ville;
          values["CAC_titulaire"]["ville_titulaireArr"] =getDetails.cityArr;
          values["CAC_titulaire"]["ville_id_titulaire"] = getDetails.ville_id;
          values["CAC_titulaire"]["greffe_titulaire"] = getDetails.area;
          setCommissaireAuxComptes(values);
          setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values })); 
        }
      }
      if(type === "CAC_suppleant"){ 
     
        let values = {...CommissaireAuxComptes};             
        // values["CAC_suppleant"]["rcs_suppleant"] =value;
        values["CAC_suppleant"]["denomination_suppleant"] = "";
        values["CAC_suppleant"]["forme_juridique_suppleant"] = "";
        values["CAC_suppleant"]["capital_suppleant"] = "";
        values["CAC_suppleant"]["adresse_suppleant"] = "";
        values["CAC_suppleant"]["code_postal_suppleant"] = "";
        values["CAC_suppleant"]["ville_suppleant"] = "";
        values["CAC_suppleant"]["greffe_suppleant"] = "";  
        values["CAC_suppleant"]["ville_suppleantArr"] =[];
        values["CAC_suppleant"]["ville_id_suppleant"] = "";       
        setCommissaireAuxComptes(values);
        setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));
        if(value.length>0){
          let getDetails = await getDetailsBySiren(value);    
          let values ={...CommissaireAuxComptes}         
          // values["CAC_suppleant"]["rcs_suppleant"] =value;
          values["CAC_suppleant"]["denomination_suppleant"] =getDetails.denomination;
          values["CAC_suppleant"]["forme_juridique_suppleant"] = getDetails.forme_juridique;
          values["CAC_suppleant"]["capital_suppleant"] = getDetails.capital_social;
          values["CAC_suppleant"]["adresse_suppleant"] = getDetails.adresse_rcs;
          values["CAC_suppleant"]["code_postal_suppleant"] =getDetails.code_postal;
          values["CAC_suppleant"]["ville_suppleant"] =getDetails.ville;
          values["CAC_suppleant"]["greffe_suppleant"] = getDetails.area;
          values["CAC_suppleant"]["ville_suppleantArr"] =getDetails.cityArr;
          values["CAC_suppleant"]["ville_id_suppleant"] = getDetails.ville_id;
          setCommissaireAuxComptes(values);
          setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values })); 
        }
      }
      
    }, 1000);
    return () => clearTimeout(getSiren);
  }
  async function getCityFromPostalType(name,value,index,type){   
    const getCity = setTimeout(async() => {
      if(type === "CAC_titulaire"){
        let values = {...CommissaireAuxComptes};
        values.CAC_titulaire.ville_titulaire = "";
        values.CAC_titulaire.ville_id_titulaire = "";
        values.CAC_titulaire.ville_id_suppleant = "";
        values.CAC_titulaire.ville_titulaireArr =[];
       
        setCommissaireAuxComptes(values);
        setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){  
            values.CAC_titulaire.ville_titulaire = response.data.data.city;
            values.CAC_titulaire.ville_id_titulaire =response.data.data.id;
            values.CAC_titulaire.greffe_titulaire =response.data.data.area;  
            values.CAC_titulaire.ville_titulaireArr = response.data.data.cityArr; 
           
            setCommissaireAuxComptes(values);
            setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));
          }
        }    
      
      }
      if(type === "CAC_suppleant"){
        let values = {...CommissaireAuxComptes};
        values.CAC_suppleant.ville_suppleant = "";
        values.CAC_suppleant.ville_suppleantArr =[];
        values.CAC_suppleant.ville_id_suppleant = "";
        values.CAC_suppleant.greffe_suppleant = "";
        setCommissaireAuxComptes(values);
        setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){  
            values.CAC_suppleant.ville_suppleant = response.data.data.city;
            values.CAC_suppleant.ville_suppleantArr = response.data.data.cityArr;
            values.CAC_suppleant.ville_id_suppleant =response.data.data.id;  
            values.CAC_suppleant.greffe_suppleant =response.data.data.area;  
            setCommissaireAuxComptes(values);
            setFormData(formData => ({ ...formData, ["CommissaireAuxComptes"]: values }));
          }
        }    
      
      }
      if(type === "Directeur_general"){
        // let values = {...Directeur_general};
        let values = Directeur_generalRef.current;
        values.ville_titulaire = "";
        values.ville_id_titulaire = "";
        values.greffe_titulaire = "";
        values.ville_titulaireArr = [];
        setDirecteur_general(values);
        setFormData(formData => ({ ...formData, ["Directeur_general"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){  
            values.ville_titulaire = response.data.data.city;
            values.ville_id_titulaire =response.data.data.id;
            values.greffe_titulaire =response.data.data.area;         
            values.ville_titulaireArr =response.data.data.cityArr;         
           
            setDirecteur_general(values);
            setFormData(formData => ({ ...formData, ["Directeur_general"]: values }));
          }
        }  
      }
      if(type === "Directeur_general_delegue"){
        let values = [...Directeur_general_delegue];
        values[index].ville_titulaire = "";
        values[index].ville_id_titulaire = "";
        values[index].greffe_titulaire = "";
        values[index].ville_titulaireArr =[];
        setDirecteur_general_delegue(values);
        setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){  
            values[index].ville_titulaire = response.data.data.city;
            values[index].ville_id_titulaire =response.data.data.id;
            values[index].greffe_titulaire =response.data.data.area;
            values[index].ville_titulaireArr = response.data.data.cityArr;

            setDirecteur_general_delegue(values);
            setFormData(formData => ({ ...formData, ["Directeur_general_delegue"]: values }));
          }
        }  
      }
      if(type === "Administrateurs"){
        let values = [...Administrateurs];
        values[index].ville_titulaire = "";
        values[index].ville_id_titulaire = "";
        values[index].greffe_titulaire = "";
        values[index].ville_titulaireArr =[];
        setAdministrateurs(values);
        setFormData(formData => ({ ...formData, ["Administrateurs"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){  
            values[index].ville_titulaire = response.data.data.city;
            values[index].ville_id_titulaire =response.data.data.id;
            values[index].greffe_titulaire =response.data.data.area;
            values[index].ville_titulaireArr = response.data.data.cityArr;

            setAdministrateurs(values);
            setFormData(formData => ({ ...formData, ["Administrateurs"]: values }));
          }
        }  
      }
      
      // 
       
    }, 1000);
    return () => clearTimeout(getCity);
  }
  async function getCityFromPostal(name,value,index,type){
    const getCity = setTimeout(async() => {
      
      if(type=== "lagrance"){
        let values = [...La_gerance];
        values[index]["villelagrance"] = "";
        values[index]["ville_id_lagrance"] = "";
        values[index]["greffelagrance"] = "";
        values[index]["villelagranceArr"] = [];
        setLa_gerance(values);
        setFormData(formData => ({ ...formData, ["La_gerance"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){          
            values[index]["villelagrance"] = response.data.data.city;
            values[index]["ville_id_lagrance"] = response.data.data.id;
            values[index]["greffelagrance"] = response.data.data.area;
            values[index]["villelagranceArr"] = response.data.data.cityArr;
            setLa_gerance(values);
            setFormData(formData => ({ ...formData, ["La_gerance"]: values }));
          }
        }  
      }
      if(type === "Associes"){
        let values = [...Les_president];
        values[index]["villeAssocies"] = "";
        values[index]["ville_id_Associes"] = "";
        values[index]["greffeAssocies"] = "";
        values[index]["villeAssociesArr"] = [];
        setLes_president(values);
        setFormData(formData => ({ ...formData, ["Les_president"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){          
            values[index]["villeAssocies"] = response.data.data.city;
            values[index]["ville_id_Associes"] = response.data.data.id;
            values[index]["greffeAssocies"] = response.data.data.area;
            values[index]["villeAssociesArr"] = response.data.data.cityArr;
            setLes_president(values);
            setFormData(formData => ({ ...formData, ["Les_president"]: values }));
          }
        }  
      }   
    }, 1000);
    return () => clearTimeout(getCity);
  }
  async function handleChange(e) {
    const { name, value } = e.target;      
    if(name == "ville_id"){
      let formDataGet = {...formData};
      let cityArrFilter = formDataGet.villeArr.filter((val,i)=>val.id==value);

      setFormData(formData => ({ ...formData, ["ville"]: cityArrFilter[0].city,["ville_id"]: value }));
    }else{
      setFormData(formData => ({ ...formData, [name]: value }));
    }
  }

  function handleChangeDate(e) {
    let newDate = moment(e.$d).format('YYYY/MM/DD');
    setFormData(formData => ({ ...formData, ["date_acte"]: newDate }));
  }
  
  async function submitPaymentDetails() { 
    let valid  = false;
    // setSubmitted(true);
    setLoading(true);
    delete paymentData['data']['billing_address_json'];
    // delete paymentData['data']['currentUserDetails'];
    delete paymentData['data']['select_cartdetailJ'];
    delete paymentData['data']['select_cartdetailN'];
    delete paymentData['data']['select_department'];
    delete paymentData['data']['votre_annonce_json'];
    delete paymentData['data']['votre_annonce'];
    delete paymentData['data']['billing_address_json_parse'];
    delete paymentData['data']['user_detail'];
    delete paymentData['data']['votre_html'];
    
    let getResponse =  await dispatch(announceActions.updatePayment({announce_id:id,user_id:currentUser && currentUser.data?currentUser.data.id:"",serenite:isCheckedSerenity,paymentData:paymentData})).then((responseData) => {         
      // // console.log("responseData",responseData)        
      return Promise.resolve(responseData);   
      
    })
    .catch((err) => {         
      return Promise.reject({
          "sucess": false,
          "msg": "Une erreur s'est produite. Veuillez réessayer!",
          "data": "",
          "insertID": ""
      });      
    });
    // setSuccessful(true);
    // // console.log("getResponse",getResponse);
    setLoading(false);
    if(getResponse.sucess === true){        
      valid = true
    }else{
      valid = false
    }
    return valid;
  }

  async function submitUserDetails() { 
    
    let valid  = false;
    // setSubmitted(true);
    if(userSelectedAddress.email && isValidEmail(userSelectedAddress.email) && userSelectedAddress.telephone && isValidPhoneNumber(userSelectedAddress.telephone)  && ((userSelectedAddress.billing_address_type === "account_address" && userSelectedAddress.billing_address_nom  && userSelectedAddress.billing_address_prenom) || (userSelectedAddress.billing_address_type === "another_address"  && userSelectedAddress.billing_address_nom  && userSelectedAddress.billing_address_prenom   && userSelectedAddress.billing_address_code_postal  && userSelectedAddress.billing_address_ville) || ( userSelectedAddress.billing_address_type === "customer_address" && (userSelectedAddress.billing_address_denomination  ||  userSelectedAddress.billing_address_address  || userSelectedAddress.billing_address_code_postal  || userSelectedAddress.billing_address_ville)) )  ){
      setLoading(true);
      let getResponse =  await dispatch(announceActions.update_user(userSelectedAddress)).then((responseData) => { 
        return Promise.resolve(responseData); 
      })
      .catch((err) => { 
        setLoading(false);        
        return Promise.reject({
            "sucess": false,
            "msg": "Une erreur s'est produite. Veuillez réessayer!",
            "data": "",
            "insertID": ""
        });      
      });
      // setSuccessful(true);
      // // console.log("getResponse",getResponse);
      setLoading(false); 
      if(getResponse.sucess === true){   
           
        valid = true
      }else{
        valid = false
      }
    }
    
    return valid;
  }
  async function handleSubmit() { 
    let valid  = false;  
    setSuccessful(false);
    setSubmitted(true);
    setSubmitted(true);
    // // console.log("formData",formData)
   
    if((((formData.type_acte === "ACTE_AUTHENTIQUE" && formData.nom_famille && formData.officiant_to) || formData.type_acte === "ACTE_SSP") && (((formData.forme_juridique === "SA") && formData.capital) || ((formData.forme_juridique === "SA à capital variable") && formData.capital_initial && formData.capital_max && formData.capital_min )) && formData.adresse && formData.code_postal && formData.ville  && (formData.Les_president.length>0 && formData.Les_president[0].type_personne_Associes))  && formData.CommissaireAuxComptes.show_data && formData.Directeur_general.show_data && (formData.Directeur_general_delegue.length>0 && formData.Directeur_general_delegue[0].show_data)) { 
    

      valid=  true;
      var valid_president = true;
      let checkLes_president = await Promise.all(formData.Les_president.map((val,key)=>{
        var status = false;
        if( val.type_personne_Associes==="PERSONNE_PHYSIQUE" && val.civilite_Associes  && val.nomAssocies && val.prenomAssocies && val.adresseAssocies && ((val.resident_etrangerAssociesphysic=="Non" && val.code_postalAssocies && val.villeAssocies)|| (val.resident_etrangerAssociesphysic=="Oui" && val.villeAssocies && val.paysAssocies ))  ){
          status= true;
        }else if( val.type_personne_Associes==="PERSONNE_MORALE" && val.siren_Associes  && val.denomination_Associes  && val.forme_juridiqueAssocies  && val.capital_Associes && val.adresseAssocies && val.code_postalAssocies && val.villeAssocies  && val.nomAssocies && val.prenomAssocies ){
          status= true;
        }        
        return status;
      })); 
      
      valid_president= !checkLes_president.includes(false);
      var valid_Directeur_general = true;
      if(formData.Directeur_general.show_data==="Oui" ){      
        let status = false;
        if( formData.Directeur_general.type_personne_titulaire==="PERSONNE_PHYSIQUE" && formData.Directeur_general.civilite_titulaire_physique && formData.Directeur_general.nom_titulaire_physique  && formData.Directeur_general.prenom_titulaire_physique  && formData.Directeur_general.adresse_titulaire  && formData.Directeur_general.code_postal_titulaire && formData.Directeur_general.ville_titulaire ){
          status= true;
        }else if(formData.Directeur_general.type_personne_titulaire==="PERSONNE_MORALE" && formData.Directeur_general.rcs_titulaire && formData.Directeur_general.denomination_titulaire  && formData.Directeur_general.forme_juridique_titulaire  && formData.Directeur_general.capital_titulaire && formData.Directeur_general.adresse_titulaire  && formData.Directeur_general.code_postal_titulaire && formData.Directeur_general.ville_titulaire  && formData.Directeur_general.nom_representee_titulaire  && formData.Directeur_general.prenom_representee_titulaire){
          status= true;
        }
        valid_Directeur_general=status;
      }
      var valid_Directeur_general_delegue = true;
      
      let checkDirecteur_general_delegue = await Promise.all(formData.Directeur_general_delegue.map((val,key)=>{        
        if(val.show_data==="Oui" ){
          var status = false;
          if((val.type_personne_titulaire==="PERSONNE_PHYSIQUE" && (val.civilite_titulaire_physique  && val.nom_titulaire_physique && val.prenom_titulaire_physique && val.adresse_titulaire && val.code_postal_titulaire && val.ville_titulaire)) ){
            // console.log("first")
            status = true;
          }else if(( val.type_personne_titulaire==="PERSONNE_MORALE" && val.rcs_titulaire  &&  val.denomination_titulaire && val.forme_juridique_titulaire  && val.capital_titulaire && val.adresse_titulaire && val.code_postal_titulaire && val.ville_titulaire && val.nom_titulaire_physique && val.prenom_titulaire_physique)) {
            status= true;
          }  
        }else if(val.show_data==="Non" ){
          var status = true;
        }      
        return status;
      }));  
      valid_Directeur_general_delegue= !checkDirecteur_general_delegue.includes(false);

      var valid_Administrateurs = true;
      
      
      let checkAdministrateurs = await Promise.all(formData.Administrateurs.map((val,key)=>{        
        if(val.show_data==="Oui" ){
          var status = false;
          if((val.type_personne_titulaire==="PERSONNE_PHYSIQUE" && (val.civilite_titulaire_physique  && val.nom_titulaire_physique && val.prenom_titulaire_physique && val.adresse_titulaire && val.code_postal_titulaire && val.ville_titulaire)) ){
            console.log("first")
            status = true;
          }else if(( val.type_personne_titulaire==="PERSONNE_MORALE" && val.rcs_titulaire  &&  val.denomination_titulaire && val.forme_juridique_titulaire  && val.capital_titulaire && val.adresse_titulaire && val.code_postal_titulaire && val.ville_titulaire && val.nom_titulaire_physique && val.prenom_titulaire_physique)) {
            status= true;
          }  
        }else if(val.show_data==="Non" ){
          var status = true;
        }      
        return status;
      }));  
      valid_Administrateurs= !checkAdministrateurs.includes(false);

      if(formData.CommissaireAuxComptes.show_data === "Non" ){
        valid= true;
      }else{
        if(formData.CommissaireAuxComptes.show_data === "Oui" &&(!formData.CommissaireAuxComptes.CAC_titulaire.type_personne_titulaire) &&(!formData.CommissaireAuxComptes.CAC_suppleant.type_personne_suppleant) ){
          valid= false;
        }else{
         
          if(formData.CommissaireAuxComptes.show_data === "Oui" && (formData.CommissaireAuxComptes.CAC_titulaire.type_personne_titulaire && ((formData.CommissaireAuxComptes.CAC_titulaire.type_personne_titulaire === "PERSONNE_PHYSIQUE" && formData.CommissaireAuxComptes.CAC_titulaire.civilite_titulaire_physique && formData.CommissaireAuxComptes.CAC_titulaire.nom_titulaire_physique  && formData.CommissaireAuxComptes.CAC_titulaire.prenom_titulaire_physique  && formData.CommissaireAuxComptes.CAC_titulaire.adresse_titulaire  && formData.CommissaireAuxComptes.CAC_titulaire.code_postal_titulaire && formData.CommissaireAuxComptes.CAC_titulaire.ville_titulaire) || (formData.CommissaireAuxComptes.CAC_titulaire.type_personne_titulaire === "PERSONNE_MORALE" && formData.CommissaireAuxComptes.CAC_titulaire.rcs_titulaire && formData.CommissaireAuxComptes.CAC_titulaire.denomination_titulaire  && formData.CommissaireAuxComptes.CAC_titulaire.forme_juridique_titulaire  && formData.CommissaireAuxComptes.CAC_titulaire.capital_titulaire && formData.CommissaireAuxComptes.CAC_titulaire.adresse_titulaire  && formData.CommissaireAuxComptes.CAC_titulaire.code_postal_titulaire && formData.CommissaireAuxComptes.CAC_titulaire.ville_titulaire))) && (formData.CommissaireAuxComptes.CAC_suppleant.type_personne_suppleant && ((formData.CommissaireAuxComptes.CAC_suppleant.type_personne_suppleant === "PERSONNE_PHYSIQUE" && formData.CommissaireAuxComptes.CAC_suppleant.civilite_suppleant_physique && formData.CommissaireAuxComptes.CAC_suppleant.nom_suppleant_physique  && formData.CommissaireAuxComptes.CAC_suppleant.prenom_suppleant_physique  && formData.CommissaireAuxComptes.CAC_suppleant.adresse_suppleant  && formData.CommissaireAuxComptes.CAC_suppleant.code_postal_suppleant && formData.CommissaireAuxComptes.CAC_suppleant.ville_suppleant) || (formData.CommissaireAuxComptes.CAC_suppleant.type_personne_suppleant === "PERSONNE_MORALE" && formData.CommissaireAuxComptes.CAC_suppleant.rcs_suppleant && formData.CommissaireAuxComptes.CAC_suppleant.denomination_suppleant  && formData.CommissaireAuxComptes.CAC_suppleant.forme_juridique_suppleant  && formData.CommissaireAuxComptes.CAC_suppleant.capital_suppleant && formData.CommissaireAuxComptes.CAC_suppleant.adresse_suppleant  && formData.CommissaireAuxComptes.CAC_suppleant.code_postal_suppleant && formData.CommissaireAuxComptes.CAC_suppleant.ville_suppleant))) ){  
            valid= true;
          }
        }
      }
    } 
    /* // console.log("valid",valid)
    return false;  */  
    if(valid === true && valid_president === true && valid_Directeur_general === true && valid_Directeur_general_delegue ===true && valid_Administrateurs === true){
      setLoading(true);
      // // console.log("formData",formData)
      let getResponse =  await dispatch(announceActions.create(formData)).then((responseData) => {         
        // // console.log("responseData",responseData)        
        return Promise.resolve(responseData);   
        
      })
      .catch((err) => { 
        // // console.log("responseData err",err) 
        setLoading(false);          
        return Promise.resolve({
            "sucess": false,
            "msg": "Une erreur s'est produite. Veuillez réessayer!",
            "data": "",
            "insertID": ""
        });      
      });
      setSuccessful(true);
      if(getResponse.sucess === true){        
        valid = true
      }else{
        valid = false
      }
    }
    
    return valid;
   
}
  function setPaymentDataFunc(data){
    setPaymentData(data);
  }

  const handlePayment =async () => {    
    if(!currentUser){
      navigate("/login");
    }
  };
  function getStepContent(step) {
    switch (step) {
      case 0: 
      return <Sa adsname={adsname.toUpperCase()} formData={formData} handleChange={handleChange} handleChangeDate={handleChangeDate} isSubmitted={isSubmitted}  addForm={addForm} La_gerance={La_gerance}  Les_president={Les_president} Directeur_general={Directeur_general} Directeur_general_delegue={Directeur_general_delegue} Administrateurs={Administrateurs}  CommissaireAuxComptes={CommissaireAuxComptes} Transmission_des_actions={Transmission_des_actions} Admission_assemblees={Admission_assemblees}  handleChangeAddForm={handleChangeAddForm} removeForm={removeForm}  />;        
      case 1:
        return <FormSummary  handleBack={handleBack} adsname={adsname.toUpperCase()}  />;
      case 2:
        return <CompleteAddress setUserSelectedAddress={setUserSelectedAddress} userSelectedAddress={userSelectedAddress}   adsname={adsname.toUpperCase()}  />;
      case 3:
        return <PaymentForm setPaymentDataFunc={setPaymentDataFunc} isCheckedSerenity={isCheckedSerenity} setIscheckedSerenity={setIscheckedSerenity} setis_general_conditions_sale={setis_general_conditions_sale} is_general_conditions_sale={is_general_conditions_sale} general_conditions_sale_msg={general_conditions_sale_msg} adsname={adsname.toUpperCase()} />;
      case 4:
       /*  return announceDetails&&announceDetails.data&&parseInt(announceDetails.data.status)===3?<FormSuccess announceDetails={announceDetails} />: activeStep===4?<Elements options={options} stripe={stripePromise}><PaymentSecond ref={childRef} payamentPrice={payamentPrice} handlePayment={handlePayment}  adsname={adsname.toUpperCase()} /> </Elements>:<PaymentSecond ref={childRef} payamentPrice={payamentPrice} handlePayment={handlePayment}  adsname={adsname.toUpperCase()} />; */
        return activeStep===4?<Elements options={options} stripe={stripePromise}><PaymentSecond ref={childRef} payamentPrice={payamentPrice} handlePayment={handlePayment} setLoading={setLoading}  adsname={adsname.toUpperCase()} /> </Elements>:<PaymentSecond ref={childRef} payamentPrice={payamentPrice} handlePayment={handlePayment} setLoading={setLoading} adsname={adsname.toUpperCase()} />;

      default:
        return 'Unknown step';
    }
  }
  
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
 

  const handleSaveAnnonce = async () => {
    setSuccessful(false)
    setLoadingFullpage(true);
    localStorage.setItem("activeStep",activeStep);
    if(!currentUser){
      navigate("/login");
      return;
    }
    try {
      const requestData = {
        announce_id: id,
        user_id: currentUser && currentUser.data?currentUser.data.id:"",
      };
      let post_url = `${process.env.REACT_APP_API_URL}api/announce/save_announce`;

      // Use Axios to make the API request
      const response = await axios.post(post_url, requestData, {
        headers: {
            'Content-Type': 'application/json',
        },
      });
      setLoadingFullpage(false);
      setSuccessful(true)
      if(response.data.sucess === true){
        navigate("/userdashboard/annonces-en-attente");
      }else{
        dispatch(alertActions.error("Une erreur s'est produite. Veuillez réessayer!")); 
      }
      
      // return {success:true,data:response.data}
    } catch (error) {
      setLoadingFullpage(false);
      setSuccessful(true)
      dispatch(alertActions.error("Une erreur s'est produite. Veuillez réessayer!"));
      // // console.log(error); 
      // return {success:false,data:""}     
    }
  }
  const handleNext = async (activeStepGet) => {
    
    let submitResult = true;
    if(!currentUser && activeStepGet !== 0 ){
      navigate("/login");
    }
    if(activeStepGet === 0){
      submitResult = await handleSubmit();
      
      
    }
    if(activeStepGet === 2)
    {
      submitResult = await submitUserDetails();
    }
    if(activeStepGet === 3)
    { 
      setgeneral_conditions_sale_msg("");
      if(!is_general_conditions_sale){
        setgeneral_conditions_sale_msg("Veuillez accepter les conditions générales de vente")
        return;
      }
      submitResult = await submitPaymentDetails();
      if(payamentPrice>0)
      {
        await fetch(process.env.REACT_APP_API_URL+`api/create-payment-intent`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [],announce_id: id,price:payamentPrice ,paymentData:paymentData.data.votre_annonce}),
        })
          .then((res) => res.json())
          .then((data) => {
            setClientSecret(data.clientSecret);
            let clientSecret = data.clientSecret
            setOptions({clientSecret,appearance})
          });
      }
    }
    if(submitResult)
    {
      setLoading(false); 
      if(isCheckedSerenity)
      {
        let adstyperedirect=Ads_redirect(formData.add_type)
        let urlredirectdata= process.env.REACT_APP_EXPERT_URL+'/'+adstyperedirect+'?ads_id='+id;
        window.location.href = urlredirectdata;
      }
      else
      {
        if(((currentUser && currentUser.UserProDetails && currentUser.UserProDetails.details && currentUser.UserProDetails.details.payment_plan && currentUser.UserProDetails.details.payment_plan.includes("monthly")) || payamentPrice==0) && activeStepGet === 3)
        {
          let payment_intent =generateRandomString();
          let payment_intent_client_secret =generateRandomString();
          navigate(location.pathname+"?activstep=5 &payment_intent="+payment_intent+"&payment_intent_client_secret="+payment_intent_client_secret);
        }
        else
        {
          let newSkipped = skipped;
          if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
          }
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setSkipped(newSkipped);  
          if(location.pathname.split('/').length ===4){
            navigate(location.pathname+"/"+announceIdRef.current);
          }
        }
      }
          
      
    }
    else{
      // let newSkipped = skipped;
      // if (isStepSkipped(activeStep)) {
      //   newSkipped = new Set(newSkipped.values());
      //   newSkipped.delete(activeStep);
      // }
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
      // setSkipped(newSkipped);
    }
  };
  const handleBack = () => {
    if(id || announceData.announce_id){
      // // console.log("location",location);
      // // console.log("location.pathname",location.pathname.split('/'));  
      setActiveStep((prevActiveStep) => prevActiveStep - 1);   
      if(location.pathname.split('/').length ===4){
        navigate(location.pathname+"/"+announceData.announce_id);
      }
      

    }else{
      setActiveStep((prevActiveStep) => prevActiveStep - 1);

    }
  };
  

  
async function updateAnnouncePayment(bodyData){
  setLoadingFullpage(true);
  try {
    let getResponse =  await dispatch(announceActions.updateSuccessPayment(bodyData)).then((responseData) => {       
      
      if(responseData.sucess == true){
        setAnnounceDetails(responseData);
        let announce = {
          "data":responseData.data,
          "announce_id":bodyData.announce_id 
        }
        dispatch({ type: announceConstants.CREATE_SUCCESS, announce});
      }
      setLoadingFullpage(false);      
      return Promise.resolve(responseData);   
      
    })
    .catch((err) => {
      setLoadingFullpage(false);           
      return Promise.reject({
          "sucess": false,
          "msg": "Une erreur s'est produite. Veuillez réessayer!",
          "data": "",
          "insertID": ""
      });      
    });
   /* return {success:true,data:response.data} */ 
  } catch (error) {
    // // console.log(error); 
    return {success:false,data:""}     
  }
}
  
async function getAnnounceDetails(announce_id){
  setLoadingFullpage(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}api/announce/announce/${announce_id}`);
    
    if(response.data.sucess === true){
       if(parseInt(response.data.data.status) === 3 || (response.data.data.length<=0)){
       navigate("/");
      }
      setAnnounceDetails(response.data);
      let announce = response.data;
      dispatch({ type: announceConstants.UPDATE_SUCCESS, announce });
    }
    setLoadingFullpage(false);
    return {success:true,data:response.data}
  } catch (error) {
    setLoadingFullpage(false);
    // // console.log(error); 
    return {success:false,data:""}     
  }
}
const handleDetailsBySiren=async(sirenNo)=>{
  let response =  await getDetailsBySiren(sirenNo);
}
  
  return (
    <>
     {loadingFullpage?
      <PageLoaderComp />
      :""}
    
     {successful?
      <ToastMessageComp  message={alert.message} type={alert.type} />
      :""}
      
      <div className='bg-mainBg'>
        <div className='md:max-w-[1200px] relative w-full h-full m-auto py-7 px-4 sm:px-4 myForm'>
          <Breadcrumb Accueil="Accueil" page={(ads.split("-")).join(" ")} />
            
          <div className='relative  bg-mainBg my-4 sm:my-12 '>
            <div className='grid grid-cols-12 gap-5  '>
              <div className='mb-8 col-span-12 lg:col-span-8'>
                <div className='hidden sm:inline-flex bg-white  mb-6 items-center justify-between w-full max-w-[974px] h-[81px] rounded-md xl:px-12  '>
                  <Stepper activeStep={queryParameters.get("activstep")?queryParameters.get("activstep"):activeStep} className='w-full  '>
                    {steps.map((label, index) => {
                      return (
                        <Step key={label}  >
                          <StepLabel>
                            <div className='inline-flex   items-center justify-between w-full'> 
                              <div className='max-w-[118px] text-black-light font-normal'>{label}</div>
                            </div>
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </div>
                
                <div className='bg-white max-w-[974px] rounded-xl  ' style={{ border: '0.5px solid #DEE3E2' }}>
                  {queryParameters.get("activstep") && parseInt(queryParameters.get("activstep")) === steps.length ? (
                    <>
                      <Typography sx={{ mt: 2, mb: 1 }}>
                        <FormSuccess announceDetails={announceDetails} loadingFullpage={loadingFullpage} />
                      </Typography>
                      
                    </>
                  ) : (
                    <>
                      <Typography  >{getStepContent(activeStep)}</Typography>
                      {
                       <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>                     
                      <button onClick={handleBack} className={activeStep === 0 ?"hidden":"w-48 h-12 m-4 rounded-md bg-thColor font-extrabold text-base sm:text-lg 3xl:text-xl text-white transition-all duration-300 hover:bg-secondary hover:btnShadow"} >
                      Précédent
                      </button>
                      <Box sx={{ flex: '1 1 auto' }} />
                      {/* onClick={() => childRef.current.getAlert()} */}
                      {/* handlePayment() */}
                      <button onClick={handleSaveAnnonce} className={activeStep === 1 ?"w-48 h-12 m-4 rounded-md bg-secondary font-extrabold text-base sm:text-lg 3xl:text-xl text-white transition-all duration-300 hover:bg-thColor hover:btnShadow":"hidden"} >
                        Enregistrer
                      </button>
                      <button disabled={loading?true:false} style={{"opacity":loading?"0.7":""}} onClick={()=>activeStep === steps.length - 1 ? childRef.current.handleSubmitCheckout():handleNext(activeStep)} className='w-48 h-12 m-4 rounded-md bg-thColor font-extrabold text-base sm:text-lg 3xl:text-xl text-white transition-all duration-300 hover:bg-secondary hover:btnShadow'>
                          {activeStep === steps.length - 1 ? `Payer ${payamentPrice} €` : activeStep ===0 ?'Calculer le prix':'Etape suivante '} 
                          {
                            loading?                         
                            <CircularProgress 
                            size={24}
                            sx={{
                              color: "white",
                              // marginTop: '-10px',
                              /* position: 'absolute',
                              top: '50%',
                              left: '50%',
                              
                              marginLeft: '-12px', */
                            }} />
                        :""}
                      </button>
                    </Box>
                    }
                    </>
                  )}
                </div>
              </div>
              <div className=' col-span-12 lg:col-span-4  '>
                <Procedures />
                <Express />
                <PaymentSideBlock />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div >
    </>
  );
}


